'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { useState } from 'react';
const STALE_TIME = 1000 * 60 * 2;
const GC_TIME = 1000 * 60 * 60 * 24;
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME,
        gcTime: GC_TIME
      }
    }
  });
}
function createPersister() {
  return createAsyncStoragePersister({
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    key: 'react-query-cache',
    serialize: data => JSON.stringify(data, (_, value) => value === undefined ? null : value)
  });
}
export const TanstackProviders = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(createQueryClient);
  const [persister] = useState(createPersister);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      shouldDehydrateQuery: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== persister) {
    t2 = {
      persister,
      maxAge: GC_TIME,
      dehydrateOptions: t1
    };
    $[1] = persister;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== queryClient || $[5] !== t2) {
    t3 = <PersistQueryClientProvider client={queryClient} persistOptions={t2}>{children}</PersistQueryClientProvider>;
    $[3] = children;
    $[4] = queryClient;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(query) {
  return query.state.status === "success" && query.meta?.persist === true;
}